import React from 'react';

import { Box, Typography } from '@rbilabs/universal-components';
import { OverSodiumLimitWarning } from 'features/menu/components/product-detail/product-price-calories/over-sodium-limit-warning';
import { ProductPriceCaloriesContainer } from 'features/menu/components/product-detail/product-price-calories/styled';
import { useProductWizardContext } from 'features/menu/components/product-wizard';
import { useProductCalories } from 'features/menu/components/product-wizard/use-product-calories';
import { useProductTotalPrice } from 'features/menu/components/product-wizard/use-product-total-price';
import { useProductWizardFlow } from 'features/menu/components/product-wizard/use-product-wizard-flow';
import { StyleSheet, View } from 'react-native';

import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

interface ProductPriceCaloriesProps {
  showPlusSign?: boolean;
}

export const ProductPriceCalories = ({ showPlusSign }: ProductPriceCaloriesProps) => {
  const isDesktop = useIsDesktopBreakpoint();
  const { selectedProduct, slotsSelections, productQuantity } = useProductWizardContext();
  const { cartIdEditing, id, rewardId } = useProductWizardFlow();
  const { formattedTotalPrice } = useProductTotalPrice({
    id,
    selectedProduct,
    slotsSelections,
    productQuantity,
    cartIdEditing,
    rewardId,
  });
  const calories = useProductCalories(selectedProduct);

  const accessibilityLabel = `${formattedTotalPrice} ${calories}`;

  const fontStyles = isDesktop ? { fontSize: 24 } : styles.priceAndCaloriesText;

  return (
    <Box focusable accessibilityLabel={accessibilityLabel}>
      <ProductPriceCaloriesContainer>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          {formattedTotalPrice && (
            <Typography testID="product-total-price" style={fontStyles}>
              {formattedTotalPrice}
            </Typography>
          )}
          {formattedTotalPrice && calories && <Typography style={fontStyles}>{'  |  '}</Typography>}
          {calories && (
            <Typography testID="product-total-calories" style={fontStyles}>
              {calories}
            </Typography>
          )}
        </View>
        <OverSodiumLimitWarning />
      </ProductPriceCaloriesContainer>
    </Box>
  );
};

const styles = StyleSheet.create({
  priceAndCaloriesText: {
    fontSize: 18,
  },
});
